import { render, staticRenderFns } from "./estadosCidades.vue?vue&type=template&id=590555aa"
import script from "./estadosCidades.vue?vue&type=script&lang=js"
export * from "./estadosCidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports